import { useRouter } from "next/router";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import notificationModel from "../../models/notifications.model";

import Heading from "../../components/Heading";
import helper from "../../lib/helper";
import _ from "lodash";
import eventModel from "../../models/event.model";
import useSWR from "swr";
import config from "../../lib/config";

import dynamic from "next/dynamic";
import "react-quill/dist/quill.snow.css";

// Dynamically import React Quill to avoid SSR issues
const ReactQuill = dynamic(() => import("react-quill"), { ssr: false });

const Page = () => {
  const router = useRouter();
  const queryParams = router.query;

  const [emailValue, setEmailValue] = useState("");

  const { data: eventData } = useSWR(
    queryParams || null,
    () => eventModel.list(queryParams),
    config.swrConfig
  );

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    setValue
  } = useForm();

  const onSubmit = handleSubmit(async (data, event) => {
    const formData = new FormData(event.target);
    formData.set("email", emailValue); // Add rich text content

    try {
      const response = await notificationModel.create(formData);
      helper.sweetalert.toast(response.data?.message, "success");
      router.push("/notificationtemplate");
    } catch (error) {
      helper.sweetalert.toast(error.response?.data?.message, "error");
      _.each(error.response?.data?.errors, function (err, errorKey) {
        setError(errorKey, { type: "required", message: err });
      });
    }
  });

  return (
    <>
      <Heading title="Create Notification template" />
      <div className="container-fluid">
        <div className="card shadow">
          <div className="card-header fs-3 ">Create Notification template</div>
          <form
            onSubmit={onSubmit}
            className="container-fluid"
            method="post"
            encType="multipart/form-data"
          >
            <div className="row mt-3">
              {/* Title */}
              <div className="col-md-6">
                <label className="form-label">Title:</label>
                <input
                  type="text"
                  placeholder="Enter Title"
                  className={`form-control ${errors?.title && "is-invalid"}`}
                  {...register("title", { required: "Title is required" })}
                />
                <div className="invalid-feedback">
                  {errors.title && errors.title.message}
                </div>
              </div>

              {/* Event dropdown */}
              <div className="col-md-6">
                <label className="form-label">Event</label>
                <select {...register("event")} className="form-select">
                  {Object.entries(eventData?.data || {}).map(
                    ([key, val], index) => (
                      <option key={index} value={key}>
                        {val}
                      </option>
                    )
                  )}
                </select>
              </div>

              {/* Email editor */}
              <div className="mt-3">
                <label className="form-label">Email</label>
                <ReactQuill
                  theme="snow"
                  value={emailValue}
                  placeholder="Enter email notification"
                  onChange={(value) => {
                    setEmailValue(value);

                    setValue("email", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  }}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],

                      ["bold", "italic", "underline", "strike"],

                      [{ color: [] }, { background: [] }],

                      [{ align: [] }],

                      [{ list: "ordered" }, { list: "bullet" }],

                      ["blockquote"],

                      ["link", "image"],

                      ["clean"],
                    ],
                  }}
                />
                <div className="invalid-feedback">
                  {errors.email && errors.email.message}
                </div>
              </div>

              {/* SMS */}
              <div className="col-md-12 mt-3">
                <label className="form-label">SMS</label>
                <textarea
                  placeholder="Enter SMS notification"
                  className={`form-control ${errors?.sms && "is-invalid"}`}
                  {...register("sms")}
                />
                <div className="invalid-feedback">
                  {errors.sms && errors.sms.message}
                </div>
              </div>

              {/* Push */}
              <div className="col-md-12 mt-3 mb-2">
                <label className="form-label">Push :</label>
                <textarea
                  placeholder="Enter Push notification"
                  className={`form-control ${errors?.push && "is-invalid"}`}
                  {...register("push")}
                />
                <div className="invalid-feedback">
                  {errors.push && errors.push.message}
                </div>
              </div>

              <div className="card-footer float-end">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-primary float-end"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Page;
